export const lang = document.documentElement.lang;

export const materials_tr = () => {
  const translate = {
    'pt-br': {
      title: 'Materiais',
      subtitle: 'Conteúdos e materiais para você entender tudo sobre o Desafio Voluntário.',
      aside: {
        all: 'Todos materiais',
        search: 'Busca',
        highlights: 'Destaques',
        close: 'Fechar',
      },
      searchbox: {
        title: 'Qual material você está procurando?',
        placeholder: 'Digite palavra-chave',
        button: 'LIMPAR BUSCA',
        mobile_filter: 'Filtrar materiais',
      },
      card: {
        load_more: 'Ver mais',
        btn_access: 'Acessar',
        btn_download: 'Baixar Material',
      },
      highlights: 'Destaques',
      button_show_more: 'MOSTRAR MAIS MATERIAIS',
      no_results: 'Nenhum resultado encontrado com os termos escolhidos, tente novamente.',
    },
    en: {
      title: 'Materials',
      subtitle: 'Conteúdos e materiais para você entender tudo sobre o Desafio Voluntário.',
      aside: {
        all: 'All materials',
        search: 'Search',
        highlights: 'Highlights',
        close: 'Close',
      },
      searchbox: {
        title: 'What material are you looking for?',
        placeholder: 'Enter the key word',
        button: 'CLEAR SEARCH',
        mobile_filter: 'Filter materials',
      },
      card: {
        load_more: 'See more',
        btn_access: 'Access',
        btn_download: 'Download Material',
      },
      highlights: 'Highlights',
      button_show_more: 'SHOW MORE MATERIALS',
      no_results: 'No results found with the chosen terms, please try again.',
    },
    es: {
      title: 'Materiales',
      subtitle: 'Contenidos y materiales para que entiendas todo sobre el Desafío Voluntario.',
      aside: {
        all: 'Todos los materiales',
        search: 'Buscar',
        highlights: 'Destacados',
        close: 'Cerrar',
      },
      searchbox: {
        title: '¿Qué material buscas?',
        placeholder: 'Introduzca la palabra clave',
        button: 'BORRAR BÚSQUEDA',
        mobile_filter: 'Filtrar materiales',
      },
      card: {
        load_more: 'Ver más',
        btn_access: 'Acceder',
        btn_download: 'Descargar Material',
      },
      highlights: 'Destacados',
      button_show_more: 'MOSTRAR MÁS MATERIALES',
      no_results: 'No se encontraron resultados con los términos elegidos, inténtelo nuevamente.',
    },
  };

  return translate[lang];
};
